import React, { Component } from 'react';
import axios from 'axios';

import Loader from './nav/Loader';

const baseResultsURL = "/results/chartsContent/json/ncaasM";

class NCAA extends Component {
  constructor(props) {
      super(props);
      this.state = {
        data: [],
        yearFilter: 2022,
        showLoader: true
      };
      this.handleYearChange = this.handleYearChange.bind(this);
  }
  componentWillMount() {
    this.getResults({
      "year": this.state.yearFilter
    });
  }
  getResults(config) {
    var url = baseResultsURL + config.year + '.json';
    axios.get(url)
    .then(response => {
      if (!response.data){

      } else {
        this.setState({
          data : response.data,
          showLoader: false
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }
  getSession(num, box) {
    if(this.state.data.set !== undefined){
      if(num < 2){
        return <div id={"box_"+box} className="clearfix">
          <h2>{this.state.data.set.session[num].name}</h2>
          <div className={"team winners team"+this.state.data.set.session[num].team[0].id}><p>{this.state.data.set.session[num].team[0].rank+'. '+this.state.data.set.session[num].team[0].text}</p></div>
          <div className={"team winners team"+this.state.data.set.session[num].team[1].id}><p>{this.state.data.set.session[num].team[1].rank+'. '+this.state.data.set.session[num].team[1].text}</p></div>
          <div className={"team winners team"+this.state.data.set.session[num].team[2].id}><p>{this.state.data.set.session[num].team[2].rank+'. '+this.state.data.set.session[num].team[2].text}</p></div>
          <div className={"team team"+this.state.data.set.session[num].team[3].id}><p>{this.state.data.set.session[num].team[3].rank+'. '+this.state.data.set.session[num].team[3].text}</p></div>
          <div className={"team team"+this.state.data.set.session[num].team[4].id}><p>{this.state.data.set.session[num].team[4].rank+'. '+this.state.data.set.session[num].team[4].text}</p></div>
          <div className={"team team"+this.state.data.set.session[num].team[5].id}><p>{this.state.data.set.session[num].team[5].rank+'. '+this.state.data.set.session[num].team[5].text}</p></div>
          </div>;
      } else {
        return <div id={"box_"+box} className="clearfix">
          <h2>{this.state.data.set.session[num].name}</h2>
          <div className={"team winners team"+this.state.data.set.session[num].team[0].id}><p>{this.state.data.set.session[num].team[0].rank+'. '+this.state.data.set.session[num].team[0].text}</p></div>
          <div className={"team team"+this.state.data.set.session[num].team[1].id}><p>{this.state.data.set.session[num].team[1].rank+'. '+this.state.data.set.session[num].team[1].text}</p></div>
          <div className={"team team"+this.state.data.set.session[num].team[2].id}><p>{this.state.data.set.session[num].team[2].rank+'. '+this.state.data.set.session[num].team[2].text}</p></div>
          <div className={"team team"+this.state.data.set.session[num].team[3].id}><p>{this.state.data.set.session[num].team[3].rank+'. '+this.state.data.set.session[num].team[3].text}</p></div>
          <div className={"team team"+this.state.data.set.session[num].team[4].id}><p>{this.state.data.set.session[num].team[4].rank+'. '+this.state.data.set.session[num].team[4].text}</p></div>
          <div className={"team team"+this.state.data.set.session[num].team[5].id}><p>{this.state.data.set.session[num].team[5].rank+'. '+this.state.data.set.session[num].team[5].text}</p></div>
          </div>;
      }
    }
  }
  getChampion() {
    if(this.state.data.set !== undefined){
      return <div id="box_champ" className="clearfix">
        <div id="champ" className="clearfix">
          <h2>{this.state.yearFilter} Champions</h2>
          <div className={"team winners team"+this.state.data.set.champion.id}><p>{this.state.data.set.champion.text}</p></div>
        </div>
      </div>;
    }
  }
  getSemifinals() {
    if(this.state.data.set !== undefined){
      return <div className="ncaa_section">
        <p className="ncaa_h1">NCAA Semifinals</p>
        <p className="ncaa_date">{this.state.data.set.session[0].meta}</p>
        <div className="medium-6 columns">
          <p className="ncaa_h2"><a href={"/results/scheduleM/meet/"+this.state.data.set.session[0].link}>Session I</a></p>
          <ol>
            <li>{this.state.data.set.session[0].team[0].score} {this.state.data.set.session[0].team[0].text}</li>
            <li>{this.state.data.set.session[0].team[1].score} {this.state.data.set.session[0].team[1].text}</li>
            <li>{this.state.data.set.session[0].team[2].score} {this.state.data.set.session[0].team[2].text}</li>
            <li>{this.state.data.set.session[0].team[3].score} {this.state.data.set.session[0].team[3].text}</li>
            <li>{this.state.data.set.session[0].team[4].score} {this.state.data.set.session[0].team[4].text}</li>
            <li>{this.state.data.set.session[0].team[5].score} {this.state.data.set.session[0].team[5].text}</li>
          </ol>
        </div>
        <div className="medium-6 columns">
          <p className="ncaa_h2"><a href={"/results/scheduleM/meet/"+this.state.data.set.session[1].link}>Session II</a></p>
          <ol>
          <li>{this.state.data.set.session[1].team[0].score} {this.state.data.set.session[1].team[0].text}</li>
          <li>{this.state.data.set.session[1].team[1].score} {this.state.data.set.session[1].team[1].text}</li>
          <li>{this.state.data.set.session[1].team[2].score} {this.state.data.set.session[1].team[2].text}</li>
          <li>{this.state.data.set.session[1].team[3].score} {this.state.data.set.session[1].team[3].text}</li>
          <li>{this.state.data.set.session[1].team[4].score} {this.state.data.set.session[1].team[4].text}</li>
          <li>{this.state.data.set.session[1].team[5].score} {this.state.data.set.session[1].team[5].text}</li>
          </ol>
        </div>
      </div>
      ;
    }
  }
  getFinals() {
    if(this.state.data.set !== undefined){
      return <div className="ncaa_section">
        <p className="ncaa_h1"><a href={"/results/scheduleM/meet/"+this.state.data.set.session[2].link}>NCAA Team Finals</a></p>
        <p className="ncaa_date">{this.state.data.set.session[2].meta}</p>
        <div className="medium-12 columns">
          <ol>
          <li>{this.state.data.set.session[2].team[0].score} {this.state.data.set.session[2].team[0].text}</li>
          <li>{this.state.data.set.session[2].team[1].score} {this.state.data.set.session[2].team[1].text}</li>
          <li>{this.state.data.set.session[2].team[2].score} {this.state.data.set.session[2].team[2].text}</li>
          <li>{this.state.data.set.session[2].team[3].score} {this.state.data.set.session[2].team[3].text}</li>
          <li>{this.state.data.set.session[2].team[4].score} {this.state.data.set.session[2].team[4].text}</li>
          <li>{this.state.data.set.session[2].team[5].score} {this.state.data.set.session[2].team[5].text}</li>
          </ol>
        </div>
      </div>;
    }
  }
  getEvent(num) {
    if(this.state.data.set !== undefined){
      let gymnasts0 = this.state.data.set.eventFinals.event[num].score[0].gymnast.map((gymnast, index) =>
        <span key={index}>{gymnast}<br /></span>
      );
      let gymnasts1 = this.state.data.set.eventFinals.event[num].score[1].gymnast.map((gymnast, index) =>
        <span key={index}>{gymnast}<br /></span>
      );
      let gymnasts2 = this.state.data.set.eventFinals.event[num].score[2].gymnast.map((gymnast, index) =>
        <span key={index}>{gymnast}<br /></span>
      );
      //let gymnasts3 = this.state.data.set.eventFinals.event[num].score[3].gymnast.map((gymnast, index) =>
      //  <span key={index}>{gymnast}<br /></span>
      //);
      return <div className="medium-6 columns">
        <p className="ncaa_h2">{this.state.data.set.eventFinals.event[num].app}</p>
        <p className="ief_score">1.&nbsp; <strong>{this.state.data.set.eventFinals.event[num].score[0].val}</strong></p><br />
        <p className="ief_gymnast">{gymnasts0}<br /></p>
        <p className="ief_score">2.&nbsp; <strong>{this.state.data.set.eventFinals.event[num].score[1].val}</strong></p><br />
        <p className="ief_gymnast">{gymnasts1}<br /></p>
        <p className="ief_score">3.&nbsp; <strong>{this.state.data.set.eventFinals.event[num].score[2].val}</strong></p><br />
        <p className="ief_gymnast">{gymnasts2}<br /></p>
      </div>;
    }
  }
  getAAChampions() {
    if(this.state.data.set !== undefined){
      let gymnasts0 = this.state.data.set.aawinner.score[0].gymnast.map((gymnast, index) =>
        <span key={index}>{gymnast}<br /></span>
      );
      let gymnasts1 = this.state.data.set.aawinner.score[1].gymnast.map((gymnast, index) =>
        <span key={index}>{gymnast}<br /></span>
      );
      let gymnasts2 = this.state.data.set.aawinner.score[2].gymnast.map((gymnast, index) =>
        <span key={index}>{gymnast}<br /></span>
      );
      if(this.state.data.set !== undefined){
        return <div className="medium-6 columns ief_margin2 clearfix">
          <p className="ncaa_h2">All Around Champion</p>
          <p className="ief_score">1.&nbsp; <strong>{this.state.data.set.aawinner.score[0].val}</strong></p><br />
          <p className="ief_gymnast">{gymnasts0}<br /></p>
          <p className="ief_score">2.&nbsp; <strong>{this.state.data.set.aawinner.score[1].val}</strong></p><br />
          <p className="ief_gymnast">{gymnasts1}<br /></p>
          <p className="ief_score">3.&nbsp; <strong>{this.state.data.set.aawinner.score[2].val}</strong></p><br />
          <p className="ief_gymnast">{gymnasts2}<br /></p>
          </div>;
      }
    }
  }
  handleYearChange(event) {
    var year = Number(event.currentTarget.value);
    if(Number(event.currentTarget.value) !== this.state.yearFilter){
      this.getResults({
        "year": year
      });
      this.setState({
        yearFilter : year,
        showLoader: true
      });
    }
  }
  render() {
    if(this.state.data.set !== undefined && this.state.showLoader !== true){
      return (
        <div>
        <div className="row expanded padding-sm-top">
            <div className="small-12 columns">
              <div className="small-12 medium-2 columns">
                <select id="year_filter" value={this.state.yearFilter} onChange={this.handleYearChange}>
                  <option value="2022">2022</option>
                  <option value="2021">2021</option>
                  <option value="2019">2019</option>
                  <option value="2018">2018</option>
                  <option value="2017">2017</option>
                  <option value="2016">2016</option>
                  <option value="2015">2015</option>
                  <option value="2014">2014</option>
                </select>
              </div>
            </div>
        </div>
        <div className="row expanded padding-sm-top">
          <div className="small-12 columns">
            <div id="title_chart"><p>{this.state.yearFilter} NCAA CHAMPIONSHIPS</p></div>
            <div id="primaryContainer" className="primaryContainer clearfix">
              {this.getChampion()}
              <div id="box_supersix" className="clearfix">
                {this.getSession(2, 'tfinals')}
              </div>
              <div id="box_nationals" className="clearfix">
                <div id="ncaas" className="clearfix">
                  {this.getSession(0, 'ncaa1')}
                  {this.getSession(1, 'ncaa2')}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row collapse padding-sm-top">
        		<div className="small-12 columns">
        			<div id="ncaa_content" className="center-row">
                {this.getSemifinals()}
                {this.getFinals()}

        				<div className="ncaa_section">
        					<p className="ncaa_h1">Individual Event Finals</p>
                  {this.getEvent(0)}
                  {this.getEvent(1)}
                  <div className="clearfix"></div>
                  {this.getEvent(2)}
                  {this.getEvent(3)}
                  <div className="clearfix"></div>
                  {this.getEvent(4)}
                  {this.getEvent(5)}
                  <div className="clearfix"></div>
                  {this.getAAChampions()}
        				</div>
        				<div className="clearfix"></div>
        			</div>
        		</div>
        	</div>
        </div>
      );
    } else {
      return <Loader />
    }
  }
}

export default NCAA;



// WEBPACK FOOTER //
// ./src/components/NCAA.js